import { Button } from '@/components';
import { PhoneLink } from '@/components/ui/PhoneLink/PhoneLink';
import { SvgPharmacy, SvgPhone } from '@/components/icons';
import { getDataAboutPharmacy } from '@/api/aboutPharmacy/api';
import { getAggregatedSchedule } from '@/api/medicalUnits/medicalUnits';
import s from './../chiefDoctorCard/chiefDoctorCard.module.scss';
import ls from './PharmacyCard.tsx.module.scss';
import { phoneForLink } from '@/utils/strings';

export default async function PharmacyCard() {
  const [
    aboutPharmacyData,
    aggregatedPharmacySchedule,
  ] = await Promise.all([
    getDataAboutPharmacy(),
    getAggregatedSchedule({ id: 2 }),
  ]);

  return (
    <div className={`${s.card} ${ls.card}`}>
      <div className={s.card__inner}>
        <SvgPharmacy />
        <h3 className={s.cardTitleSurname}>Аптека</h3>
        <p className={s.cardSubtitle}>График работы</p>
        <div className={s.cardTextSchedule}>
          {aggregatedPharmacySchedule.map((item, index) => {
            const [day, value] = Object.entries(item)[0];
            return (
              <div key={index} className={s.cardTextSchedule__row}>
                <span>{day}</span>
                {value.open_time
                  ? <span>{value.open_time} - {value.close_time}</span>
                  : <span>{value.reason || 'Выходной день'}</span>
                }
              </div>
            );
          })}
        </div>
        <p className={s.cardSubtitle}>Телефон</p>
        <p className={s.cardText}>
          <PhoneLink phone={aboutPharmacyData.main_phone} codeIsFour />
        </p>
      </div>

      <a className={ls.card__buttonWrapper} href={`tel:${phoneForLink(aboutPharmacyData.main_phone)}`}>
        <Button
          className={ls.card__button}
          name="Позвонить"
          type="button"
          theme="primary"
          size="default"
          leftIcon={<SvgPhone />}
        />
      </a>
    </div>
  );
}